import BaseSliderManager from "../../../../../src/managers/BaseSliderManager/BaseSliderManager";
import { SliderGenProps } from "../../../../../src/types/Interface";
import { SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL } from "../types/Config";
import { eventBus, EnumEventBus } from "./EventBus";


const SliderGen: SliderGenProps[] = [
	{
		head: "move chord",
		colors: {
			bgColor: 0x21D4FE,
			barColor: 0x000000,
			buttonColor: 0x21D4FE
		},
		keepCurrSlider: true,
		onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveChord, v - 100)
	},
	{
		head: "move circumference point",
		colors: {
			bgColor: 0xB5A1FF,
			barColor: 0x000000,
			buttonColor: 0xB5A1FF
		},
		onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveCircumPoint, v - 100)
	}
]


export default class SliderManager extends BaseSliderManager {
	constructor() {
		super(SliderGen, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);
	}
}